<template src="./Edit.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  props: {
    itemId: {
      type: Number,
      required: true,
    },
  },
  mounted() {
  this.$nextTick(() => {
    const form = this.$el.querySelector('form');
    form.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
      }
    });
  });
},

  created() {
    this.$store.dispatch("lookups/getMedicines");
    this.$store.dispatch("lookups/getSuppliers");

    this.$store.dispatch("purchaseOrders/getForEdit", this.itemId).then((res) => {
      this.vm = res
    });
    this.$store.dispatch("lookups/getStores");

  },
  computed: {
    medicines() {
      return this.$store.state.lookups.medicines;
    },
    suppliers() {
      return [
        ...this.$store.state.lookups.suppliers
      ];
    },
    stores() {
      return this.$store.state.lookups.stores;
    },
  },
  data() {
    return {
      vm: {
        storeId: null,
        supplierId: null,
        invoiceNo: null,
        orderDate: null,
        receivedDate: null,
        medicines: []
      },
      medicine: {
        medicineId: null,
        batchNo: null,
        quantity: null,
        purchasePrice: null,
        expirationDate: null,
      },
      indexItem: null,
      editFlag: false,
      headers: [
        { text: 'اسم الدواء', value: 'medicineId' },
        { text: ' رقم التشغيلة', value: 'batchNo' },
        { text: 'الكمية', value: 'quantity' },
        { text: 'سعر القطعة', value: 'purchasePrice' },
        { text: 'تاريخ  انتهاء الصلاحية ', value: 'expirationDate' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
    };
  },
  methods: {
    confirm() {
      if(this.vm.medicines.length == 0){
        showAlert(`يجب ادخال عنصر واحد على الاقل`);
        return false;
      }
    
      this.$store
        .dispatch("purchaseOrders/edit", { id: this.itemId, payload: this.vm })
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    AddItem() {
      if (this.medicine.medicineId == null) {
        showAlert(`يجب اختيار الدواء `);
        return false;
      } else if (this.medicine.quantity == null) {
        showAlert(`يجب ادخال الكمية   `);
        return false;
      } else if (this.medicine.batchNo == null) {
        showAlert(`يجب ادخال رقم التشغيلة`);
        return false;
      } else if (this.medicine.expirationDate == null) {
        showAlert(`يجب اختيار تاريخ انتهاء الصلاحية   `);
        return false;
      }
      this.vm.medicines.push({
        medicineId: this.medicine.medicineId,
        quantity: this.medicine.quantity,
        batchNo: this.medicine.batchNo,
        expirationDate: this.medicine.expirationDate,
        purchasePrice: this.medicine.purchasePrice,
      });
      
      this.medicine.medicineId = null;
      this.medicine.batchNo = null;
      this.medicine.quantity = null;
      this.medicine.expirationDate = null;
      this.medicine.purchasePrice = null;
      //this.$refs.info.reset();
    },
    getEditItem(item) {
      this.indexItem = this.vm.medicines.findIndex((x) => x.medicineId == item.medicineId);
      this.medicine.medicineId = this.vm.medicines[this.indexItem].medicineId;
      this.medicine.batchNo = this.vm.medicines[this.indexItem].batchNo;
      this.medicine.quantity = this.vm.medicines[this.indexItem].quantity;
      this.medicine.expirationDate = this.vm.medicines[this.indexItem].expirationDate;
      this.medicine.purchasePrice = this.vm.medicines[this.indexItem].purchasePrice;
      this.editFlag = true;
    },
    EditItem() {
      // let Index = this.jobGrades.findIndex((x) => x.value == this.vm.jobGradeId);

      if (this.medicine.medicineId == null) {
        showAlert(`يجب اختيار الدواء `);
        return false;
      } else if (this.medicine.quantity == null) {
        showAlert(`يجب ادخال الكمية   `);
        return false;
      } else if (this.medicine.batchNo == null) {
        showAlert(`يجب ادخال رقم التشغيلة`);
        return false;
      } else if (this.medicine.expirationDate == null) {
        showAlert(`يجب اختيار تاريخ انتهاء الصلاحية   `);
        return false;
      }
      this.vm.medicines[this.indexItem].medicineId = this.medicine.medicineId;
      this.vm.medicines[this.indexItem].quantity = this.medicine.quantity;
      this.vm.medicines[this.indexItem].batchNo = this.medicine.batchNo;
      this.vm.medicines[this.indexItem].expirationDate = this.medicine.expirationDate;
      this.vm.medicines[this.indexItem].purchasePrice = this.medicine.purchasePrice;

      this.medicine.medicineId = null;
      this.medicine.batchNo = null;
      this.medicine.quantity = null;
      this.medicine.expirationDate = null;
      this.medicine.purchasePrice = null;
      this.indexItem = null;
      this.editFlag = false;
      //this.$refs.info.reset();
    },

    removeItem(index) {
      this.vm.medicines.splice(index, 1);
    },
    handleClear() {
      this.vm.orderDate = null;
    },
    allowedDates(val) {
      const today = new Date();
      const date = new Date(val);
      return date >= today;
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>